module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SitePage_Support

(function (fox, $) {
	
	fox.registerWidget('SitePage_Support', {

		configure: function () {
			this.registerOptions('', {
				pageContainer: '#page-container',
				widgets: {
					helpRequest: {
						widget: 'Help_Request',
					},
					supportPostGetApi: {
						widget: 'Api',						
						method: 'Support.getPost'
					},

					searchPost: {
						widget: 'Grid',
						'embed.container': '#spt_page',
						template: 'support_post_menu',
						autoRender: true,
						externalLoad: true,
						active: false,
						group: 'pageContent',
						list: {
							'embed.container': '#supportPostTitles',
							'tpl.row': 'support_post_menu_row'
						},
						'widgets.dl': {
							widget: 'Datalayer',
							method: 'Support.searchPost'
						}
					},
					supportPostsList: {
						widget: 'Grid',
						container: '#spt_page',
						template: 'support_post_menu',
						externalLoad: true,
						autoRender: true,
						active: false,
						group: 'pageContent',
						list: {
							'embed.container': '#supportPostTitles',
							'tpl.row': 'support_post_menu_row'
						},
						'widgets.dl': {
							widget: 'Datalayer',
							method: 'Support.get',
							transitParameters: {
								status: 2
							}
						}
					},
					supportPostContent: {
						widget: 'Widget',
						active: false,
						autoRender: true,
						group: 'pageContent',
						'embed.container': '#spt_page',
						template: 'support_post_content'
					},

					// supportTagsList: {
					// 	widget: 'Grid',
					// 	'embed.container': '#left-menu',
					// 	'embed.widget': '@parent @parent',
					// 	autoRender: true,
					// 	list: {
					// 		'tpl.row': 'support_tag'
					// 	},
					// 	'widgets.dl': {
					// 		widget: 'Datalayer',
					// 		method: 'Support.getAllTags',
					// 	}
					// }
				},		
				handleWom: {
					navi: {
						widget: fox.Navigator,
						event: 'modified_2',
						callback: '_loadInfo',
						params: {
							//alwaysActive: true,
							listenHistory: true
						}
					},					
					supportPostGetApiReady: {
						widget: '#supportPostGetApi',
						event: 'success',
						callback: '_loadPost'
					},
					supportTagsListLoaded: {
						widget: '#supportPostsList #dl',
						event: 'loaded',
						callback: '_loadPostsList'	
					},
					supportSearchListLoaded: {
						widget: '#searchPost #dl',
						event: 'loaded',
						callback: '_loadSearchPage'	
					}		
				},

				handleDom: {
					showHelpRequestPopup: {
						event: 'click',
						target: '.help-request-block',
						callback: '#helpRequest:show'
					},
					searchArticle: {
						event: 'click',
						target: '#search-article .icon',
						callback: 'searchPost'
					},
					searchArticleOnKeyPress: {
						event: 'input',
						target: '#search-article input',
						callback: 'searchPost'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this._timeout = 0;
			this._search = this.rwom1('#searchPost');

			this.callParent('running', arguments);
		},

		addedToDom: function() { 
			//redirect from support to support/tag/Account
			if (/^support\/?$/i.test(fox.Navigator.location)) {
				fox.site.gotoPage("support/tag/Account");
			};

			this.callParent('addedToDom', arguments);
		},

		searchPost: function(el, methodAlias,performer, event) {
			console.log('searchPost', arguments)
			if (event.type === 'keyup' && event.keyCode !== 13) {
				return;
			}			

			var phrase = $(el).is('input') ? $(el).val() : $(el).siblings('input').val();;

			this._search.setTemplateOptions({
				tag: decodeURIComponent('Search results for "' + phrase + '"')
			});

			clearTimeout(this._timeout);
			
			this._timeout = setTimeout(fox.bind(function() {
				this._search.dl.setTransitParameter('phrase', phrase).load();
			}, this), 500);
		},

		_loadPost: function (data) {
			data = data.answer.response;
			//this.prepareContentsData(data.contents);

			this.switchEmbeddedWidget('supportPostContent');
			this.rwom1('#supportPostContent')
				.setTemplateOptions({					
					contents: fox.toArray(data.contents),
					post: data
				})
				.render();

			this.dispatchEvent('postLoaded', data)
		},

		_loadPostsList: function (data) {
			this.switchEmbeddedWidget('supportPostsList');

			this.rwom1('#supportPostsList')
				.setTemplateOptions({
					tag: decodeURIComponent(fox.Navigator.get(2))
				})
				.render();
		},

		_loadSearchPage: function () {
			fox.site.gotoPage('support/search');

			this.switchEmbeddedWidget('searchPost');

			this.rwom1('#searchPost')
				.render();
		},

		_loadInfo: function (param) {
			switch (fox.Navigator.get(1)) {
				case 'tag':
					this.rwom1('#supportPostsList')
						.dl
						.setTransitParameter('tags', encodeURIComponent(param))
						.load();
					break;
				case 'post':
					this.rwom1('#supportPostGetApi')
						.send({id:param});
					break;
				case 'search':
					break;
				default:
					//redirect from support to support/tag/Account
					if (/^support\/?.*$/i.test(fox.Navigator.location)) {
						fox.site.gotoPage("support/tag/Account");
					};
					break;
			}

		},

	}, 'Site_Page');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/sitepage/support.js
// module id = 477
// module chunks = 2